import { render, staticRenderFns } from "./SlotModule.vue?vue&type=template&id=465312d7&lang=pug"
import script from "./SlotModule.vue?vue&type=script&lang=js"
export * from "./SlotModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports